import React from "react";
import {
  CaseInfoHeader,
  CaseInfoHeaderFields,
} from "../../../../../shared/case-info-header/case-info-header";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryDocument } from "../../../../../../generated";

interface HeaderSummaryContainerProps {
  caseId: string;
}

export const HeaderSummaryContainer: React.FC<HeaderSummaryContainerProps> = (
  props
) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryDocument,
    {
      variables: {
        archivedCredentialVerificationCaseSummaryId: props.caseId,
      },
    }
  );

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName:
        applicantDetailData?.archivedCredentialVerificationCaseSummary
          ?.applicant?.displayName ?? "",
      id:
        applicantDetailData?.archivedCredentialVerificationCaseSummary
          ?.applicant?.id ?? "",
    },
    submittedAt:
      applicantDetailData?.archivedCredentialVerificationCaseSummary
        ?.submittedAt ?? "",
    lastActivityAt:
      applicantDetailData?.archivedCredentialVerificationCaseSummary
        ?.lastActivityAt ?? "",
    id: applicantDetailData?.archivedCredentialVerificationCaseSummary?.id,
  };

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={<CaseInfoHeader data={caseInfoData} caseType="credentialVerification" />}
    />
  );
};
